module.exports = __webpack_public_path__ + "img/gift_top-orange_bg.ecc0d5e1.png";